import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import './styles/App.css';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './routes/AppRoutes';

const App = () => (
    <ThemeProvider>
      <Router>
        <div className="app">
          <main className="app__main">
            <AppRoutes />
          </main>
        </div>
      </Router>
    </ThemeProvider>
);

export default App;
